import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowDownTriangleSquare,
  faArrowProgress,
  faBell,
  faBook,
  faBrakeWarning,
  faBuildingUser,
  faBullhorn,
  faBullseye,
  faCalendar,
  faChartBar,
  faChartLine,
  faChartSimple,
  faCircleCheck,
  faCircleDot,
  faCircleExclamation,
  faCircleExclamationCheck,
  faCircleInfo,
  faCirclePlay,
  faCircleXmark,
  faClipboardCheck,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faCube,
  faCubes,
  faCubesStacked,
  faDatabase,
  faDiagramProject,
  faEnvelope,
  faEnvelopeOpenText,
  faFile,
  faFileChartColumn,
  faFileLines,
  faFiles,
  faFlag,
  faFrame,
  faGear,
  faGearCode,
  faGearComplexCode,
  faGears,
  faHammer,
  faHandHoldingDollar,
  faHome,
  faIdBadge,
  faImage,
  faInfinity,
  faInfoCircle,
  faLayerGroup,
  faLightbulb,
  faLinesLeaning,
  faLink,
  faList,
  faListCheck,
  faListTree,
  faLock,
  faM,
  faMagnifyingGlassChart,
  faMegaphone,
  faMemo,
  faMemoCircleInfo,
  faMerge,
  faMobileScreenButton,
  faPaintRoller,
  faPaperPlane,
  faPen,
  faPenField,
  faPipeSection,
  faPlay,
  faPlusCircle,
  faQrcode,
  faQuestion,
  faR,
  faRectangleApi,
  faRectangleHistory,
  faRectangleList,
  faShapes,
  faShieldCheck,
  faSitemap,
  faSliders,
  faStamp,
  faTable,
  faTableList,
  faTag,
  faTags,
  faThumbtack,
  faTriangleExclamation,
  faUser,
  faUserGroup,
  faUsers,
  faUserShield,
  faUsersLine,
  faW,
  faWandMagicSparkles,
  faWarehouse,
  faWebhook,
  faXmark
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faClock,
  faStamp,
  faSliders,
  faChartBar,
  faArrowDownTriangleSquare,
  faArrowProgress,
  faBell,
  faBook,
  faBrakeWarning,
  faBuildingUser,
  faBullhorn,
  faBullseye,
  faCalendar,
  faChartLine,
  faChartSimple,
  faCircleCheck,
  faCircleDot,
  faCircleExclamation,
  faCircleExclamationCheck,
  faCircleInfo,
  faCirclePlay,
  faCircleXmark,
  faClipboardCheck,
  faClipboardListCheck,
  faClockRotateLeft,
  faCube,
  faCubes,
  faCubesStacked,
  faDatabase,
  faDiagramProject,
  faEnvelope,
  faEnvelopeOpenText,
  faFile,
  faFileChartColumn,
  faFileLines,
  faFiles,
  faFlag,
  faFrame,
  faGear,
  faGearCode,
  faGearComplexCode,
  faGears,
  faHammer,
  faHandHoldingDollar,
  faHome,
  faIdBadge,
  faImage,
  faInfinity,
  faMemoCircleInfo,
  faInfoCircle,
  faLayerGroup,
  faLightbulb,
  faLinesLeaning,
  faLink,
  faList,
  faListCheck,
  faListTree,
  faLock,
  faM,
  faMagnifyingGlassChart,
  faMegaphone,
  faMemo,
  faMerge,
  faMobileScreenButton,
  faPaintRoller,
  faPaperPlane,
  faPen,
  faPenField,
  faPipeSection,
  faPlay,
  faPlusCircle,
  faQrcode,
  faQuestion,
  faR,
  faRectangleApi,
  faRectangleHistory,
  faRectangleList,
  faShapes,
  faShieldCheck,
  faSitemap,
  faTable,
  faTableList,
  faTag,
  faTags,
  faThumbtack,
  faTriangleExclamation,
  faUser,
  faUserGroup,
  faUsers,
  faUserShield,
  faUsersLine,
  faW,
  faWandMagicSparkles,
  faWarehouse,
  faWebhook,
  faXmark
);
